import React from 'react';
import {
  createFileRoute,
  useParams,
  useNavigate,
} from '@tanstack/react-router';
import { workspaceRegistry } from '../../../../components/onboarding/registry/WorkspaceRegistry';
import { useWorkspaces } from '../../../../components/onboarding/apis/workspace-registry';
import { SettingsLayout } from '../../../../components/Pleri/components/Settings/SettingsLayout';

import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/settings/tools/workspace/$workspaceId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('pleri/pages');
  const { workspaceId } = useParams({
    from: '/settings/tools/workspace/$workspaceId',
  });
  const navigate = useNavigate();
  const { data: workspaces } = useWorkspaces();

  const workspaceState = workspaces?.find(
    (w) => w.workspaceType === workspaceId,
  );
  const isEnabled = workspaceState?.enabled ?? false;

  // Get workspace registration from registry
  const workspaceRegistration = workspaceRegistry.getWorkspace(workspaceId);

  if (!workspaceRegistration) {
    return (
      <SettingsLayout>
        <div className="flex flex-1 items-center justify-center p-8">
          <div className="text-center">
            <h2 className="mb-2 text-xl leading-tight font-semibold text-gray-900 dark:text-gray-100">
              {t('workspaceNotFound')}
            </h2>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              {t('theRequestedWorkspaceConfigurationCouldNotBe')}
            </p>
            <button
              onClick={() => navigate({ to: '/settings/tools' })}
              className="rounded-lg bg-orange-600 px-4 py-2 text-white transition-colors hover:bg-orange-700"
            >
              {t('backToTools')}
            </button>
          </div>
        </div>
      </SettingsLayout>
    );
  }

  const { config: workspaceConfig, setupComponent: SetupComponent } =
    workspaceRegistration;

  const handleComplete = async () => {
    navigate({ to: '/settings/tools' });
  };

  const handleCancel = () => {
    navigate({ to: '/settings/tools' });
  };

  return (
    <SettingsLayout>
      <div className="flex-1 overflow-hidden">
        <div className="relative h-full">
          {/* Back Button - Floating */}
          <button
            onClick={handleCancel}
            className="absolute top-4 left-4 z-10 inline-flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-100"
          >
            {t('backToToolsArrow')}
          </button>

          {/* Configuration Content */}
          <div className="h-full overflow-auto px-6 py-6">
            <SetupComponent
              workspace={{
                ...workspaceConfig,
                enabled: isEnabled,
                config: workspaceState?.config,
              }}
              onComplete={handleComplete}
              onCancel={handleCancel}
            />
          </div>
        </div>
      </div>
    </SettingsLayout>
  );
}
